const workflowLibraryAsset = {
  id: null,
  name: null,
  fileName: null,
  contentType: null,
  s3Key: null,
  isActive: true,
  createdBy: null,
  updatedBy: null,
  createdAt: null,
  updatedAt: null
}

export default () => Object.assign({}, workflowLibraryAsset)
